// extracted by mini-css-extract-plugin
export default {"sellingInfo":"Ui6b59a5gbTyIsanmdez","name":"Nr1xWAJjGRSoSldSMeJT","incomeInfo":"zlWQHFm7dv3XuYCIuLli","diffWrapper":"__X9B4Qx_35CSlFuTTyA"};